<template>
  <transition appear name="modal">
    <aside v-if="state.isVisible" :class="classes" :id="processID">
      <div class="modal-wrapper" @mousedown="outsideStartClick" @mouseup="outsideClick" ref="modalWrapper">
        <div class="modal-container">
          <div class="modal-body px-4">
            <button v-if="isShouldCancelOnX" type="button" @click.prevent.self="hide($event)" class="btn-icon grey-to-red close close-modal" :class="closeBtnSize">
              <span class="sr-only">Dismiss Modal</span>
              <icon class="times"></icon>
            </button>

            <slot></slot>
            <transition name="fade-in-out" mode="out-in">
              <div v-if="isInStatus(ModalStatus.None)" :key="ModalStatus.None">
                <slot name="body"></slot>
              </div>
              <div v-if="isInStatus(ModalStatus.Confirmation)" :key="ModalStatus.Confirmation">
                <slot :name="ModalStatus.Confirmation">
                  Confirmation
                </slot>
              </div>
              <div v-if="isInStatus(ModalStatus.InProgress)" :key="ModalStatus.InProgress">
                <div class="spinner">
                  <img src="@assets/images/_icon-spinner.svg" alt="Loading Spinner">
                  <slot :name="ModalStatus.InProgress">
                    In Progress
                  </slot>
                </div>
              </div>
              <div v-if="isInStatus(ModalStatus.Successful)" :key="ModalStatus.Successful">
                <slot :name="ModalStatus.Successful">
                  Successful
                </slot>
              </div>
              <div v-if="isInStatus(ModalStatus.Failure)" :key="ModalStatus.Failure">
                <slot :name="ModalStatus.Failure">
                  Failed
                </slot>
              </div>
              <template v-for="status in customStatuses">
                <div v-if="isInStatus(status)" :key="status">
                  <slot :name="status" />
                </div>
              </template>
            </transition>
          </div>
        </div>
      </div>
    </aside>
  </transition>
</template>

<script lang="ts">
  import Vue from "vue";
  import {ModalStatus} from "../models/modalStatus";
  import CTooltip from "../modules/cTooltip/tooltipManager";
  import { EnumHelper } from '../helpers/enumHelper'
  import {StringHelper} from "../helpers/stringHelper";
  import {ModalID} from "~/enums/modalID"

  export default Vue.extend({
    props: {
      state: Object,
      shouldCancelOnOutsideClick: {
        type: Boolean,
        default: true
      },
      shouldCancelOnX: {
        type: Boolean,
        default: true
      },
      size: {
        type: String,
        default: ''
      },
      shouldCancelOn: {
        type: Boolean,
        default: null,
      },
      focusSelector: String,
      closeBtnSize: {
        type: String,
        default: 'md'
      },
      customStatuses: {
        type: Array as () => Array<string | number>,
        default: () => [],
        validator: function (array) {
          return array.every(x => !EnumHelper.toArray(ModalStatus).includes(x))
        },
      },
      preventEsc: {
        type: Boolean,
        default: false
      }
    },
    data: function() {
      return {
        ModalStatus: ModalStatus,
        clickStartedOutside: false
      }
    },
    created() {
      $(<any>window).on('keydown.toggleModal', this.handleKeydown);
    },
    beforeDestroy() {
      $(<any>window).off('keydown.toggleModal', this.handleKeydown);
    },
    methods: {
      outsideClick(event): void {
        if (this.isShouldCancelOnOutsideClick &&
          this.clickStartedOutside &&
          event.target === this.$refs.modalWrapper) {
          this.hide(event);
        }
      },
      outsideStartClick(event): void {
        this.clickStartedOutside = event.target === this.$refs.modalWrapper;
      },
      hide(event) {
        this.emitToggle(event, false);
      },
      emitToggle(event: Event = null, isVisibleOverride: boolean = null): void {
        this.$emit('toggle-modal', {event: event, id: this.state.id, isVisible: isVisibleOverride === null ? !this.state.isVisible : isVisibleOverride});
      },
      handleKeydown(event) {
        if (event.key === 'Escape' && !this.preventEsc) {
          this.hide(event);
        }
      },
      focus() {
        this.$nextTick(() => {
          let $input = $(this.$el).find(this.focusSelector || 'input');
          if ($input.length > 0) {
            $input.get(0).focus();
          }
        });
      },
      isInStatus(status: any): boolean {
        return this.state.status === status;
      }
    },
    computed: {
      processID() {
        let result = '';
        let hasIndex = this.index !== '';
        let hasIndexOnObject = ModalID.hasOwnProperty(this.index);

        if(hasIndexOnObject){
          result = 'modal-' + StringHelper.camelToDash(this.vueModalID[parseInt(this.index, 10)]);
        } else if(hasIndex) {
          result = 'modal-' + this.index;
        }
        return result;
      },
      classes() {
        return [
          'modal-mask',
          'v-modal',
          this.size
        ];
      },
      isVisible: {
        get(): boolean {
          return this.state.isVisible;
        },
        set(newVal: boolean) {
          this.state.isVisible = newVal;
        }
      },
      isShouldCancelOnDefined(): boolean {
        return this.shouldCancelOn !== null;
      },
      isShouldCancelOnX(): boolean {
        if (this.isShouldCancelOnDefined) {
          return this.shouldCancelOn;
        } else {
          return this.shouldCancelOnX;
        }
      },
      isShouldCancelOnOutsideClick(): boolean {
        if (this.isShouldCancelOnDefined) {
          return this.shouldCancelOn;
        } else {
          return this.shouldCancelOnOutsideClick;
        }
      },
    },
    watch: {
      isVisible(showing, hiding) {
        CTooltip.clearTooltips();
        if (showing && !hiding) {
          // this.emitToggle(); //currently breaks things -- but toggle should emit
          this.focus();
        }
      }
    }
  });
</script>
